export default __webpack_public_path__ + "static/media/factory.48dbf198.png";